import FieldRAG, {RAG_OPTIONS_NO_NOT_SET} from "../../../../fields3/generic/rag/rag";
import FieldConfig from "../../../proto/field-config";
import Project from "../../../../model2/project/project";


export default class FieldProjectHealth extends FieldRAG {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Health";
        this.label              = _.get(config, 'label', "Project Health")

        // Check settings
        if (!gd.company.settings.fields.projectHealthCanHaveNoValue) {
            this.options = RAG_OPTIONS_NO_NOT_SET
        }

    }

    // ACCESS
    canEdit(model:Project):boolean {
        return model.acl.canChangeHealth
    }

}